/* eslint-disable no-console */
import _ from 'underscore';
import { getDeviceLocation } from './modules/location-utils';
import { getItemsFromAccount, removeItemFromAccount, saveItemToAccount } from './modules/consumer-account/storage-actions';
import { getParameterByName } from './utils/url-utils';
import DealerAvailabilityModal from './modules/dealer-availability-modal';
import dealerContactModal from './modules/dealer-contact/dealer-contact-modal';
import initDealerContactForm from './modules/dealer-contact/dealer-contact-form';

// console.log('\n\n\n*************************\n\nlocator.js ver: 2.3.0 \n\n*************************\n\n\n');

const dealerGridDiv = document.getElementById('dealerGrid');
const dealerResultsHeading = document.getElementById('dealerResultsHeading');
const searchBtn = document.querySelector('.map-search-button');
const searchBtnDefaultVal = searchBtn.value;
const { jsApiKey } = window;
const labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const mapDiv = document.getElementById('locatorMap');
const mapInit = window.locatorMap;
const maxMarkers = 10;
const noContentDiv = document.getElementById('locatorMapNoContent');
const requestUrl = window.getLocationsPath;
let savedDealerData = [];

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const dealerCardTemplate =
  `<div class="dealer-card" data-dealer-record-id="{{ recordid }}">
    <div class="dealer-card--banner {{ (premiumpartner ? 'premium-partner' : '') }}">
      <div class="dealer-card--label">{{ (premiumpartner ? 'Premium Dealer' : '') }}</div>
      <div class="dealer-card--letter">{{ label }}</div>
    </div>
    <div class="dealer-card--content">
      <div class="dealer-card--name heading-sm mb-0">{{ businessname }}</div>
      <div class="heading-xxs mb-2">{{ (shopathomeindicator ? 'Design Consultant' : 'Showroom') }}</div>
      <div class="dealer-card--contact mb-1">
        <p class="body-sm driving-distance">{{ drivingdistance }} mi</p>
        {{ (addressline1 && addressline1 !== '' ? addressline1 + '<br />' : '') }}
        {{ (addressline2 && addressline2 !== '' ? addressline2 + '<br />' : '') }}
        <span>{{ city }}, {{ state }} {{ postalcode }}</span><br />
        <a class="phone-link" href="tel:{{ phonenumber }}" data-name="{{ businessname }}">{{ phonenumber }}</a><br />
      </div>
      {{ (website && website !== '' ? '<a href="' + website + '" target="_blank">Website</a><br />' : '') }}
    </div>
    <button class="savebutton btn-secondary btn-sm" data-record-id="{{ recordid }}" data-dealer-name="{{ businessname }}">
        <div class="savebutton--label">Make <span class="sr-only">{{ businessname }} </span>My Dealer</div>
    </button>
  </div>`;

const dealerInfoWindowTemplate =
  `<div class="dealer-card info-window-card">
    <div class="dealer-card--content">
      <div class="dealer-card--name heading-sm mb-0">{{ businessname }}</div>
      <div class="heading-xxs mb-2">{{ (shopathomeindicator ? 'Design Consultant' : 'Showroom') }}</div>
      <div class="dealer-card--contact body-md mb-1">
        <p class="body-sm driving-distance">{{ drivingdistance }} mi</p>
        {{ (addressline1 && addressline1 !== '' ? addressline1 + '<br />' : '') }}
        {{ (addressline2 && addressline2 !== '' ? addressline2 + '<br />' : '') }}
        <span>{{ city }}, {{ state }} {{ postalcode }}</span><br />
        <a class="phone-link" href="tel:{{ phonenumber }}" data-name="{{ businessname }}">{{ phonenumber }}</a><br />
      </div>
      {{ (website && website !== '' ? '<a href="' + website + '" target="_blank" class="body-md">Website</a><br />' : '') }}
    </div>
  </div>`;

let activeMarker;
let bounds = null;
let mapLocations = [];
let map = null;
let markers = [];
let submitErrorText = '';
let userLocationData;

const titleize = (str) => {
  if (!str || str === null) {
    return str;
  }
  let upper = true;
  let newStr = '';
  for (let i = 0; i < str.length; i++) { /* eslint-disable-line no-plusplus */
    if (str[i] === ' ') {
      upper = true;
      newStr += str[i];
      continue; /* eslint-disable-line no-continue */
    }
    newStr += upper ? str[i].toUpperCase() : str[i].toLowerCase();
    upper = false;
  }
  return newStr;
};

const dealerCardTemplateVals = _.template(dealerCardTemplate);
const dealerInfoWindowTemplateVals = _.template(dealerInfoWindowTemplate);

const getDealerDataByRecordId = id => (
  mapLocations.find(dealer => dealer.recordid === id)
);

const getSavedDealerBtn = () => {
  const id = savedDealerData[0].recordid;
  const savedBtnSelector = `.savebutton[data-record-id="${id}"]`;
  return dealerGridDiv.querySelector(savedBtnSelector);
};

const toggleDealerAccountStatus = () => {
  // console.log(savedDealerData);
  const activeBtnSelector = '.savebutton.is-active';
  const activeDealerBtn = dealerGridDiv.querySelector(activeBtnSelector);
  if (activeDealerBtn) {
    activeDealerBtn.classList.remove('is-active');
    const dealerName = activeDealerBtn.getAttribute('data-dealer-name');
    activeDealerBtn.querySelector('.savebutton--label').innerHTML = `Make<span class="sr-only"> ${dealerName}</span> My Dealer`;
    activeDealerBtn.closest('.dealer-card').classList.remove('my-expert');
  }
  // Check if there's a saved dealer?
  if (savedDealerData.length !== 0) {
    const savedDealerBtn = getSavedDealerBtn();
    if (savedDealerBtn) {
      savedDealerBtn.classList.add('is-active');
      savedDealerBtn.querySelector('.savebutton--label').innerHTML = 'Remove My Dealer';
      savedDealerBtn.closest('.dealer-card').classList.add('my-expert');
    }
  }
};

const checkSavedDealerMatch = (recordid) => {
  if (savedDealerData.length === 0) {
    return false;
  }
  if (savedDealerData[0].recordid === recordid) {
    return true;
  }
  return false;
};

const removeDealerFromAccount = () => {
  // console.log('locator.js, removeDealerFromAccount');
  const { assetId } = savedDealerData[0];
  const btn = getSavedDealerBtn();
  // Disable button
  btn.setAttribute('disabled', 'disabled');
  removeItemFromAccount('location', assetId, () => {
    // Remove existing dealer from savedDealerData array
    savedDealerData = [];
    // Update button/card state
    toggleDealerAccountStatus();
    // Enable button
    btn.removeAttribute('disabled');
  });
};

const onSavedDealerDataLoaded = (data) => {
  savedDealerData = [data];
  // Look up all dealer cards
  const dealerCards = dealerGridDiv.querySelectorAll('.dealer-card');
  for (let i = 0; i < dealerCards.length; i++) { /* eslint-disable-line no-plusplus */
    const card = dealerCards[i];
    // console.log(`${card.getAttribute('data-dealer-record-id')}/${data.recordid}`);
    if (card.getAttribute('data-dealer-record-id') === data.recordid) {
      toggleDealerAccountStatus();
    }
  }
};

const addSaveDealerToAccountHandlers = () => {
  const btns = dealerGridDiv.querySelectorAll('.savebutton');
  for (let i = 0; i < btns.length; i++) { /* eslint-disable-line no-plusplus */
    const btn = btns[i];
    const recordid = btn.getAttribute('data-record-id');
    // Check to see if dealer card record-id matches saved dealer... if saved dealer exists
    // console.log(`${recordid}, ${checkSavedDealerMatch(recordid)}`);
    if (checkSavedDealerMatch(recordid)) {
      toggleDealerAccountStatus();
    }
  }
  // Add eventlisteners for saving/removing dealer... outside for loop
  const saveBtns = document.querySelectorAll('.savebutton');
  [].map.call(saveBtns, btn => btn.addEventListener('click', () => {
    if (btn.classList.contains('is-active')) {
      // Remove
      removeDealerFromAccount();
    } else {
      // Disable button
      btn.setAttribute('disabled', 'disabled');
      // Save
      const recordid = btn.getAttribute('data-record-id');
      // console.log(recordid);
      const dealerData = getDealerDataByRecordId(recordid);
      // console.log('locator.js, saveDealerToAccount');
      saveItemToAccount(
        'location',
        dealerData,
        (data) => {
          if (data.success) {
            // Remove existing dealer from savedDealerData array
            savedDealerData = [];
            // Add reference to saved data...
            onSavedDealerDataLoaded({
              assetId: data['asset-id'],
              recordid: dealerData.recordid,
            });
            btn.removeAttribute('disabled');
          } else {
            btn.removeAttribute('disabled');
          }
        },
      );
    }
  }));
};

const disableSearchButton = () => {
  searchBtn.setAttribute('disabled', 'disabled');
  searchBtn.value = 'Searching...';
};

const enableSearchButton = () => {
  searchBtn.removeAttribute('disabled');
  searchBtn.value = searchBtnDefaultVal;
};

const getValidAddress = (str) => {
  if (str === '') {
    return false;
  }
  return true;
};

const showMap = (bool) => {
  // Show map, hide initial message area
  if (bool) {
    mapDiv.classList.add('locator-map-expanded');
    noContentDiv.classList.add('hidden');
  } else {
    mapDiv.classList.remove('locator-map-expanded');
    noContentDiv.classList.remove('hidden');
  }
};

const initMap = () => {
  /* eslint-disable no-undef */
  bounds = new google.maps.LatLngBounds();
  map = new google.maps.Map(mapDiv, {
    center: new google.maps.LatLng(43.1162759, -89.5101693),
  });
  /* eslint-enable no-undef */
};

const appendMapScript = () => {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${jsApiKey}&callback=initMap`;
  document.body.appendChild(script);
};

const adjustZoomAfterBounds = () => {
  // Don't allow extreme zoom when there's (likely) only one result
  const listener = google.maps.event.addListener(map, 'idle', () => { /* eslint-disable-line no-undef */
    if (map.getZoom() > 13) {
      map.setZoom(13);
    }
    google.maps.event.removeListener(listener); /* eslint-disable-line no-undef */
  });
};

const updateLocations = () => {
  // Remove any map markers
  markers.forEach((item) => {
    item.setMap(null);
  });
  // Remove any cards in grid
  dealerGridDiv.innerHTML = '';
  // Reset bounds
  bounds = new google.maps.LatLngBounds(); /* eslint-disable-line no-undef */
  // Restrict number of locations to max or under (should always be equal to max)
  let len = maxMarkers;
  if (mapLocations.length < maxMarkers) {
    len = mapLocations.length;
  }
  // Add locations & markers
  let position;
  let icon;
  let marker;
  let infowindow;
  let div;
  let loc;
  let i = 0;
  do {
    loc = mapLocations[i];
    loc.label = labels.substr(i, 1);
    // Map accountnumber to recordid for matching
    position = new google.maps.LatLng(loc.latitude, loc.longitude); /* eslint-disable-line no-undef */

    icon = {
      url: `${window.imagePath}icon-marker.svg`,
      scaledSize: new google.maps.Size(36, 36), /* eslint-disable-line no-undef */
    };

    marker = new google.maps.Marker({ /* eslint-disable-line no-undef */
      position,
      animation: google.maps.Animation.DROP, /* eslint-disable-line no-undef */
      map,
      label: { text: loc.label, color: 'white' },
      icon,
    });

    marker.infowindowHtml = loc;

    infowindow = new google.maps.InfoWindow({ /* eslint-disable-line no-undef */
      content: '',
      maxWidth: 240,
    });

    markers.push(marker);
    map.fitBounds(bounds.extend(position));
    adjustZoomAfterBounds();
    // Add dealer cards to grid
    const compiled = dealerCardTemplateVals(loc);
    div = document.createElement('div');
    div.innerHTML = compiled;
    dealerGridDiv.appendChild(div.firstChild);
    i += 1;
  }
  while (i < len);

  addSaveDealerToAccountHandlers();

  markers.forEach(item => item.addListener('click', () => {
    // Reset active marker
    if (activeMarker !== undefined) {
      activeMarker.setIcon({
        url: `${window.imagePath}icon-marker.svg`,
        scaledSize: new google.maps.Size(36, 36), /* eslint-disable-line no-undef */
      });
    }
    // Set active marker
    item.setIcon({
      url: `${window.imagePath}icon-marker-active.svg`,
      scaledSize: new google.maps.Size(36, 36), /* eslint-disable-line no-undef */
    });
    infowindow.setContent(dealerInfoWindowTemplateVals(item.infowindowHtml));
    infowindow.open(map, item);
    // Set this as active item
    activeMarker = item;
  }));

  // Check to see if a user has a dealer saved to their account
  const { isAuthenticated } = window;
  if (isAuthenticated) {
    getItemsFromAccount('location', (data) => {
      const { dealer } = data;
      // console.log(dealer);
      // See if that dealer matches a dealer in the results and update card formatting
      if (dealer) {
        onSavedDealerDataLoaded({
          assetId: dealer['dealer-id'],
          recordid: dealer['record-id'],
        });
      }
    });
  }
  dealerResultsHeading.classList.remove('hidden');
  dealerResultsHeading.innerHTML = `Results: ${len} Dealers`;
  dealerResultsHeading.focus();
};

const displayNoResultsMessage = () => {
  // Reset map state
  showMap(false);
  bounds = null;
  // Remove any existing markers
  markers.forEach((item) => {
    item.setMap(null);
  });
  markers = [];
  // Remove any cards in grid
  dealerGridDiv.innerHTML = '';
  // Hide results heading
  dealerResultsHeading.classList.add('hidden');
  // Reset no results message
  noContentDiv.innerHTML = window.noResultsMessage;
  // set focus to no results message
  noContentDiv.focus();
};

const mapLocationDataProperties = (data) => {
  const arr = data.map((item) => {
    const o = {};
    Object.keys(item).forEach((key) => {
      o[key.replace(/-/g, '')] = item[key];
    });
    o.addressline1 = titleize(o.addressline1);
    o.addressline2 = titleize(o.addressline2);
    o.businessname = titleize(o.businessname);
    o.distance = parseInt(o.distance, 10).toFixed(2);
    o.city = titleize(o.city);
    // Legacy, needed for existing account api
    o['record-id'] = o.recordid;
    o['ship-to-account'] = o.shiptoaccount;
    return o;
  });
  return arr;
};

const formatLocationResults = (data) => {
  mapLocations = mapLocationDataProperties(data['get-locations-response'].locations);
  if (mapLocations.length === 0) {
    displayNoResultsMessage();
    // Show dealer availability modal
    DealerAvailabilityModal({
      state: 'dealer-not-available',
    });
    return;
  }
  if (mapInit.init === true && map === null) {
    initMap();
  }
  showMap(true);
  updateLocations();
};

const requestLocationData = (options) => {
  const {
    address,
    latitude,
    longitude,
    radius,
  } = options;
  const {
    dataLayer,
  } = window;
  const {
    utmCampaign,
    utmContent,
    utmMedium,
    utmSource,
    utmTerm,
  } = dataLayer[0];
  const postData = `brandcode=${window.brandCode}&countrycode=US&latitude=${latitude}&longitude=${longitude}&address=${address}&radius=${radius}&results=10&netsales=0&businessname=&utmcampaign=${utmCampaign}&utmcontent=${utmContent}&utmmedium=${utmMedium}&utmsource=${utmSource}&utmterm=${utmTerm}`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  request.onload = () => {
    enableSearchButton();
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      formatLocationResults(data);
    }
  };
  request.onerror = () => {
    enableSearchButton();
    displayNoResultsMessage();
  };

  if (window.localTesting && window.locationData !== undefined) {
    request.onloadend = () => {
      enableSearchButton();
      formatLocationResults(window.locationData);
    };
  }
  request.send(postData);
};

const onSetLocationSuccess = (data) => {
  const radius = document.querySelector('#radius-input').value;
  // Wipe out anything in address field
  document.querySelector('#address-input').value = '';
  // Clear out errors
  const errorMessageDiv = document.querySelector('.dealer-locator .error-message');
  errorMessageDiv.classList.remove('field-validation-error');
  errorMessageDiv.classList.add('field-validation-valid');
  userLocationData = data;
  requestLocationData({
    latitude: userLocationData.coords.lat,
    longitude: userLocationData.coords.lng,
    radius,
  });
};

const locateDealers = () => {
  disableSearchButton();
  const addrDiv = document.querySelector('[for="address-input"]');
  const address = document.querySelector('#address-input').value;
  const radius = document.querySelector('#radius-input').value;
  const validOpt1 = getValidAddress(address) && radius !== '';
  const validOpt2 = userLocationData !== null && userLocationData !== undefined && radius !== '';
  const errorMessageDiv = document.querySelector('.dealer-locator .error-message');

  if (validOpt1 || validOpt2) {
    errorMessageDiv.classList.remove('field-validation-error');
    errorMessageDiv.classList.add('field-validation-valid');
    addrDiv.classList.remove('error');
    submitErrorText = '';
    if (validOpt1) {
      requestLocationData({
        address,
        radius,
      });
    } else {
      requestLocationData({
        latitude: userLocationData.coords.lat,
        longitude: userLocationData.coords.lng,
        radius,
      });
    }
    return;
  }

  if (!getValidAddress(address) && radius === '') {
    submitErrorText = 'Enter a valid address or zip code and select a radius';
  } else if (radius === '') {
    submitErrorText = 'Select a radius';
  } else if (!getValidAddress(address)) {
    submitErrorText = 'Enter a valid address or zip code';
    addrDiv.classList.add('error');
  }
  errorMessageDiv.innerHTML = submitErrorText;
  errorMessageDiv.classList.add('field-validation-error');
  errorMessageDiv.classList.remove('field-validation-valid');
  enableSearchButton();
};

const onEnterKeyPress = (event) => {
  if (event.code === 'Enter') {
    locateDealers();
  }
};

const dealerPhoneClick = (name, phone) => {
  window.triggerCustomGAEvent({
    category: 'Dealer Locator Result',
    action: 'dealer-phone-click',
    label: `${name},${phone}`,
    value: '',
  });
};

const setScrollToLocateDealerSection = () => {
  const headerOffset = 108;
  const locatorWrapper = document.querySelector('.dealer-locator-wrapper');
  const y = locatorWrapper.offsetTop - headerOffset;
  window.scrollTo({
    top: y,
    behavior: 'smooth',
  });
};

const locateDealersByUrlParams = () => {
  const urlZip = getParameterByName('zipcode');
  const urlRadius = getParameterByName('radius');
  // If zip exists run dealer look-up w/ radius (if also passed) or default radius value
  if (urlZip !== '') {
    const addressIpt = document.querySelector('#address-input');
    addressIpt.value = urlZip;
    if (urlRadius !== '') {
      const radiusIpt = document.querySelector('#radius-input');
      radiusIpt.value = urlRadius;
    }
    // Run look-up
    locateDealers();
    // Scroll to div
    setTimeout(setScrollToLocateDealerSection, 1000);
  }
};

const init = () => {
  appendMapScript();
  // Search button event handler
  searchBtn.addEventListener('click', (event) => {
    event.preventDefault();
    locateDealers();
  });
  // Add keypress event listener when address input has focus
  document.querySelector('.locator-form').addEventListener('focus', () => {
    document.addEventListener('keypress', onEnterKeyPress);
  });
  document.querySelector('.locator-form').addEventListener('blur', () => {
    document.removeEventListener('keypress', onEnterKeyPress);
  });
  // Use my location event handler
  document.querySelector('.use-my-location-button').addEventListener('click', () => {
    disableSearchButton();
    getDeviceLocation({
      success: onSetLocationSuccess,
    });
  });
  // Add click events for phone numbers in map cards
  document.addEventListener('click', (event) => {
    const btn = event.target;
    if (btn.classList.contains('phone-link')) {
      const name = btn.getAttribute('data-name');
      const phone = btn.textContent;
      dealerPhoneClick(name, phone);
    }
  });
  // Init dealer contact form, set up events
  initDealerContactForm();
  // Check url params for zip (and radius)
  locateDealersByUrlParams();
};

export default {
  init,
};

if (document.querySelector('.find-a-dealer-page')) {
  init();
}

if (document.querySelector('.dealer-contact-modal')) {
  dealerContactModal();
}
/* eslint-enable no-console */
